import type { SearchData } from "../../types";
import type {
  CourtOptionPaginationControls,
  SearchOption,
} from "../../types/searchSessions";
import CourtSelectField from "./CourtSelectField";

interface HighCourtSessionFieldsProps {
  searchData: Pick<SearchData, "highcourt" | "bench" | "benchRoom">;
  highCourts: SearchOption[];
  benches: SearchOption[];
  benchRooms: SearchOption[];
  onInputChange: (field: keyof SearchData, value: string) => void;
  disabled?: boolean;
  standalone?: boolean;
  controls?: CourtOptionPaginationControls;
}

const HighCourtSessionFields = ({
  searchData,
  highCourts,
  benches,
  benchRooms,
  onInputChange,
  disabled = false,
  standalone = true,
  controls = {},
}: HighCourtSessionFieldsProps) => {
  const fields = (
    <>
      <CourtSelectField
        id="highcourt"
        label="High Court"
        options={highCourts}
        value={searchData.highcourt}
        onChange={(value) => onInputChange("highcourt", value)}
        disabled={disabled}
        placeholder="Select High Court"
        paginationControl={controls.highCourts}
      />
      <CourtSelectField
        id="bench"
        label="Bench"
        options={benches}
        value={searchData.bench}
        onChange={(value) => onInputChange("bench", value)}
        disabled={disabled || !searchData.highcourt}
        placeholder="Select Bench"
        paginationControl={controls.benches}
      />
      <CourtSelectField
        id="bench-rooms"
        label="Bench Rooms"
        options={benchRooms}
        value={searchData.benchRoom}
        onChange={(value) => onInputChange("benchRoom", value)}
        disabled={disabled || !searchData.bench}
        placeholder="Select Bench Room"
        paginationControl={controls.benchRooms}
      />
    </>
  );

  if (!standalone) {
    return fields;
  }

  return <div className="grid grid-cols-1 md:grid-cols-3 gap-3">{fields}</div>;
};

export default HighCourtSessionFields;
